module.exports = __webpack_public_path__ + "static/img-how-use-cl-617ffe6f022a4971cdb26768611ba86d.webp";